import Vue from 'vue'
import VueI18n from 'vue-i18n'

import enMessages from '@/lang/en'
import zhHansMessages from '@/lang/zhHans'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'zhHans', // set locale
  fallbackLocale: 'zhHans',
  messages: {
    en: enMessages,
    zhHans: zhHansMessages,
  }, // set locale messages
  silentTranslationWarn: true
})